module.exports = __webpack_public_path__ + "static/img/icon-ph.4624403a.png";